export interface CreateContactRequest {
  partnerId: string;
  firstname: string;
  lastname: string;
  country: string;
  district: string;
  region: string;
  city: string;
  address: string;
  phoneNumber: number;
  email: string;
  motivation: ContactMotivation
}

export enum ContactMotivation {
  INFO = 'INFO',
  APPOINTMENT = 'APPOINTMENT',
  QUOTE = 'QUOTE'
}

export const ContactMotivationLabels: Record<ContactMotivation, string> = {
  [ContactMotivation.INFO]: "Information",
  [ContactMotivation.APPOINTMENT]: "Appointment",
  [ContactMotivation.QUOTE]: "Quote",
};

